module.exports = __webpack_public_path__ + "static/img/sec-btn-active.6fff4f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/sec-btn-active.png
// module id = PM5l
// module chunks = 1